import { useParams } from 'react-router-dom';
import api from '../../services/api';
import { useQuery } from "@tanstack/react-query";

const empty = {
    id: null,
    name: null,
    status: null,
    labels: null,
    reviews_statistics: null,
    code: null,
    disable_reason: null,
    question_ids: null,
    vendor_id: null,
    created: null,
    updated: null,
}

export const getEmptyCompanies = () => {
    return { ...empty };
}

export const useGetCompany = (id = null) => {
    const { profileId: urlProfileId } = useParams();
    const profileId = id || urlProfileId;

    const fetchData = async () => {
        const { data } = profileId ? await api.get(`/companies/${profileId}/`) : { data: null };
        return data;
    };
    return useQuery({
        queryKey: ['company', profileId],
        queryFn: fetchData,
        enabled: !!profileId,
    });
};
